export const pageLayoutTypes = {
  CENTER: 'center',
  SPLIT: 'split',
  DOUBLE: 'double',
  DOUBLE_BANNER: 'double_banner',
};
